import { Helmet } from 'react-helmet';

export const websiteUrl = "https://www.agatasawickamakeup.pl";
export const mainImage = `${websiteUrl}/images/wedding_makeup.jpg`;
export const MainHelmet = () => {

    // Structured data for local business
    const localBusinessSchema = {
        "@context": "https://schema.org",
        "@type": "BeautySalon",
        "name": "Agata Sawicka Makeup Studio",
        "image": mainImage,
        "description": "Profesjonalna makijażystka w Gdyni. Makijaż ślubny, okolicznościowy, oraz lekcje makijażu. Dojazd do klientki.",
        "address": {
            "@type": "PostalAddress",
            "streetAddress": "Miętowa 3/05",
            "addressLocality": "Gdynia",
            "postalCode": "81-577",
            "addressCountry": "PL"
        },
        "geo": {
            "@type": "GeoCoordinates",
            "latitude": "54.4645595",
            "longitude": "18.4579667"
        },
        "url": websiteUrl,
        "telephone": "+48502403212",
        "priceRange": "$$",
        "openingHoursSpecification": {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": [
                "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
            ],
            "opens": "08:30",
            "closes": "14:00"
        },
        "sameAs": [
            "https://www.instagram.com/agatasawickamakeup/",
            "https://booksy.com/pl-pl/214831_agata-sawicka-makeup-artist_makijaz_3_gdynia"
        ]
    };

    return <>
        {/* @ts-ignore */}
        <Helmet>
            {/* Basic Meta Tags */}
            <html lang="pl" />
            <title>Agata Sawicka - Profesjonalna Makijażystka Gdynia | Makijaż Ślubny i Okolicznościowy</title>

            {/* OpenGraph Tags */}
            <meta property="og:locale" content="pl_PL" />
            
            {/* Additional SEO Tags */}
            <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large" />
            <link rel="canonical" href={websiteUrl} />
            <meta name="author" content="Agata Sawicka" />
            <meta name="geo.region" content="PL-PM" />
            <meta name="geo.city" content="Gdynia" />
            <meta name="geo.placename" content="Gdynia" />
            <meta name="geo.position" content="54.4645595;18.4579667" />

            {/* Mobile Tags */}
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <meta name="theme-color" content="#E2D7D0" />
            <meta name="mobile-web-app-capable" content="yes" />
            <meta name="apple-mobile-web-app-capable" content="yes" />
            <meta name="apple-mobile-web-app-status-bar-style" content="default" />

            {/* Structured Data */}
            <script type="application/ld+json">
                {JSON.stringify(localBusinessSchema)}
            </script>
        </Helmet>
    </>
}